// Single source of truth for the intake → worker API base URL.
// - Production builds (vite build, no MODE override): hit the prod worker.
// - Dev (`portless leap21-intake vite` / `vite dev`): hit local wrangler.
// - Override via VITE_API_URL when needed (preview deploys, staging worker).
//
// Previously each page hardcoded `import.meta.env.VITE_API_URL || "http://localhost:8787"`,
// which meant the prod bundle baked in localhost when VITE_API_URL wasn't
// set during the CI build — every prescreen request 404'd in prod.

const PROD_WORKER = "https://leap21-enrollment.leap21.workers.dev";
const DEV_WORKER = "http://localhost:8787";

export const API_BASE: string =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.MODE === "production" ? PROD_WORKER : DEV_WORKER);
